import React, { useState } from 'react';
import { Cell, flexRender, Row } from '@tanstack/react-table';
import { createStyles } from '@/contexts/theme-context';
import { Pressable } from 'react-native';
import { PricingHubRecentChangeRow } from '@sales-portal/domain/pricing/screens/overview/types';
import { TableCell } from '@experiences/components/table/table-cell';
import { TableRow } from '@experiences/components/table/table-row';

interface Props {
  index: number;
  onRowPress?: (row: PricingHubRecentChangeRow) => void;
  row: Row<PricingHubRecentChangeRow>;
}

export const PricingRecentPriceChangesTableRow = React.memo<Props>(
  ({ index, onRowPress, row }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [styles] = useStyles();

    const cells = row
      .getVisibleCells()
      .map((cell: Cell<PricingHubRecentChangeRow, unknown>) => (
        <TableCell
          cell={cell}
          key={cell.id}
          style={isHovered ? styles.hovered : undefined}
        >
          {flexRender(cell.column.columnDef.cell, {
            ...cell.getContext(),
            index,
          })}
        </TableCell>
      ));

    if (!onRowPress) {
      return <TableRow index={index}>{cells}</TableRow>;
    }

    return (
      <Pressable
        accessibilityLabel={row.original.item}
        accessibilityRole="button"
        onHoverIn={() => setIsHovered(true)}
        onHoverOut={() => setIsHovered(false)}
        onPress={() => onRowPress(row.original)}
      >
        <TableRow index={index}>{cells}</TableRow>
      </Pressable>
    );
  },
);

const useStyles = createStyles((theme) => ({
  hovered: {
    backgroundColor: theme.sk.color.bg.primary.hover,
  },
}));
